import { styled } from 'opensolar-ui'
import { FC } from 'react'
import { AssetsConfig, HighlightConfig } from '../expoStand'
import HighlightCard from './common/HighlightCard'

interface PropTypes {
  highlights: HighlightConfig[]
  brandLogoUrl?: string
  isExpoHomepage?: boolean | undefined
  assets?: AssetsConfig
}

const HighlightsWrapper = styled('div', { name: 'HighlightsWrapper' })({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 20,
})

const Highlights: FC<PropTypes> = ({ highlights, brandLogoUrl, isExpoHomepage, assets }) => {
  if (!highlights) return null
  return (
    <HighlightsWrapper>
      {highlights.map((card) => {
        return (
          <HighlightCard
            key={card.id}
            highlight={card}
            brandLogoUrl={brandLogoUrl}
            isExpoHomepage={isExpoHomepage}
            assets={{
              promoImage: assets?.highlights?.[card.id]?.promoImage,
            }}
          />
        )
      })}
    </HighlightsWrapper>
  )
}

export default Highlights
